export default {"src":"/_next/static/media/0xf28164a485b0b2c90639e47b0f377b4a438a16b1.f0346cd9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};